import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, MapPin, MessageSquare, Globe } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Partners() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  const { profile } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/partners").then(({ data }) => setRows(data)).catch((e) => { setErr(errMsg(e)); setRows([]); });
  }, []);

  const chat = async (p) => {
    try {
      const { data } = await api.post("/chat/conversations", { partner_id: p.partner_id });
      navigate(`/chat?c=${data.conversation_id}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-testid="partners-page">
      <span className="eyebrow">The 1031 Club</span>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight mt-4">Referral partners</h1>
      <p className="text-white/55 mt-3 max-w-2xl">CPAs, attorneys, brokers and advisors in the network. Visible to members only.</p>
      {rows === null ? <div className="py-24 flex justify-center"><Loader2 className="animate-spin text-qi-pink" /></div>
        : err ? <div className="glass-card p-10 mt-10 text-center text-white/60" data-testid="partners-error">{err}</div>
          : rows.length === 0 ? <div className="glass-card p-10 mt-10 text-center text-white/50" data-testid="partners-empty">No approved referral partners yet.</div>
            : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
                {rows.map((p) => (
                  <div key={p.partner_id} className="glass-card p-6 flex flex-col gap-4" data-testid={`partner-card-${p.partner_id}`}>
                    <div>
                      <span className="text-[10px] font-bold uppercase tracking-wider bg-qi-pink/15 text-qi-pink rounded-full px-2.5 py-1">{p.profession}</span>
                      <h3 className="font-display text-lg font-bold mt-3">{p.firm}</h3>
                      <p className="text-xs text-white/50 mt-1 inline-flex items-center gap-1"><MapPin size={12} />{p.name} · {p.city ? `${p.city}, ` : ""}{p.state}</p>
                    </div>
                    <p className="text-sm text-white/60 line-clamp-3">{p.bio}</p>
                    <div className="flex gap-3 mt-auto">
                      {profile && <button onClick={() => chat(p)} className="btn-pink !py-2 !px-4 text-sm" data-testid={`partner-chat-button-${p.partner_id}`}><MessageSquare size={14} /> Chat</button>}
                      {p.website && <a href={p.website.startsWith("http") ? p.website : `https://${p.website}`} target="_blank" rel="noreferrer" className="btn-ghost !py-2 !px-4 text-sm"><Globe size={14} /> Website</a>}
                    </div>
                  </div>
                ))}
              </div>
            )}
    </div>
  );
}
